import React from "react";
import styles from "./styles/DialogCloseButton.module.css";
import { ReactComponent as IconXmark } from "../../../assets/xmark.svg";
/**
 * Customizable button component
 * can be used as a standard close button or as a tab close button
 */
const DialogCloseButton = ({
    size, // {String} - The size of the button, can be adapt, small or adapt
    inputId,

    onClickFuction, // {Function} - The function to call on button click
    grayClicked, // {Boolean} - Flag to gray the background when disabled (CSS)
    disabled, // {Boolean} - Flag to disable the button (CSS)

    disableHTML, // {Boolean} - Flag to disable the button in HTML
}) => {
    /**
     * Handles custom disable button in conjunction with hoverFlag
     */

    return (
        <button
            id={inputId}
            name={inputId}
            className={`${styles.button_base} ${
                size === "small" ? styles.small : ""
            }   ${disabled ? styles.button_disable : styles.button}  ${
                grayClicked ? styles.grayed : ""
            } ${disabled ? styles.button_disable : ""} flex-container`}
            onClick={onClickFuction}
            type={"button"}
            aria-label={`cancel button`}
            disabled={disableHTML}
        >
            {<IconXmark className={`${styles.icon} icon-component`} />}
        </button>
    );
};

export default DialogCloseButton;
